import { Component, Input } from '@angular/core';
import { NbDialogRef, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { Mission } from '../../classes';
import { MissionService } from '../../_services/index';

import { first } from 'rxjs/operators';

@Component({
    selector: 'app-import-mission-template',
    templateUrl: './import-mission-template.component.html',
    styleUrls: ['./import-mission-template.component.scss'],
    standalone: false
})

export class ImportMissionTemplateComponent {

  @Input() missions;
  @Input() template;
  @Input() gameUid;

  positions = NbGlobalPhysicalPosition;
  loading = false;
  checkedMissions = {};
  selectAll = false;

  constructor(protected ref: NbDialogRef<ImportMissionTemplateComponent>,
    public missionService: MissionService,
    private toastrService: NbToastrService) {  
  }

  ngOnInit() {
    for (let i = 0; i < this.missions.length; i++) {
      this.checkedMissions[this.missions[i].id] = false;
    }
  }

  toggle(checked: boolean, id) {
    this.checkedMissions[id] = checked;
    this.checkAllSelected();
  }
  
  toggleAll(checked: boolean) {
    for (let i = 0; i < this.missions.length; i++) {
      this.checkedMissions[this.missions[i].id] = checked
    }
    this.selectAll = checked
  }

  checkAllSelected(){
    let allSelected = true;
    for (let i = 0; i < this.missions.length; i++) {
      if(!this.checkedMissions[this.missions[i].id]){
        allSelected = false;
        break;
      }
    }
    this.selectAll = allSelected;
  }

  cancel() {
    this.ref.close();
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  async importMissionSelected(){
    this.loading = true;
    await this.ok().then(data => {
      this.showToast('Success', 'success', `Import Mission success`, 'done-all-outline')
      this.loading = false;
      this.ref.close();
    }).catch(error => {
      this.showToast('Error', 'danger', `Import Mission failed`, 'close-outline')
      this.loading = false;
    })
  }
  async ok() {
    let missionsSelected = []
    for (let i = 0; i < this.missions.length; i++) {
      if(this.checkedMissions[this.missions[i].id]){
        //missionsSelected.push(this.missions[i])
        //
        console.log('import mission:'+this.missions[i].id);
        await this.importMissionFromTemplate(this.missions[i].id);
      } 
    }
    this.ref.close(missionsSelected);
  }
  
  getTemplateMission(id){
    if(this.template){
      for(let mission of this.template.missions){
        if(id == mission.id){
          return mission;
        }
      }
    }
    return null;
  }
  
  async importMissionFromTemplate(missionId){
    let templateMission = this.getTemplateMission(missionId);
    if(templateMission){
      //link mission to game
      /*let mission = new Mission(`games/${this.gameUid}/missions`);
      mission.fromJSON(templateMission);
      mission.collectionPath = `games/${this.gameUid}/missions`;
      mission.orderNum = this.missions.length+1;
      mission.gameId = this.gameUid;
      this.missionService.addMission(mission);*/
      let res = await this.missionService.updateMissionFromTemplate(this.gameUid,missionId,this.template.id,missionId).pipe(first()).toPromise();
      console.log('RES:'+JSON.stringify(res));
    }
  }
}
